// Ongoing SPLIT.IO Treatments
// Do NOT put prefixes "user_" & "enterprise_" within your split names
export const FEATURE_FLAGS = {
  FORMS_FILE_REQUEST_BLUEPRINT: 'forms_file_request_blueprint',
  FORMS_FILE_REQUEST_DASHBOARD_FILTER_BLUEPRINT:
    'forms_file_request_dashboard_filter_blueprint',
  RELAY_FORMS_GA: 'relay_forms_ga',
  FORMS_TOS: 'forms_tos',
  FORMS_SUBMISSIONS_LIST_SHOW_ALL_FIELDS:
    'forms_submissions_list_show_all_fields',
  FORMS_ENABLE_EMAIL_ADDRESS: 'forms-enable-email-address',
  FORMS_ENABLE_INLINE_FOLDER_SELECTOR: 'forms_enable_inline_folder_selector',
  FORMS_RICH_TEXT_TOOLBAR_REFACTOR: 'forms_rich_text_toolbar_refactor',
  FORMS_DELETE_FORM: 'forms_delete_form',
} as const;

export type FeatureFlag = (typeof FEATURE_FLAGS)[keyof typeof FEATURE_FLAGS];
